module.exports = __webpack_public_path__ + "static/logo-tiny-87006562e415a01f6cad8002c5c8635f.png";